module.exports = __webpack_public_path__ + "img/7.91e9e7fc.png";